import { getModalActions } from '@tls/ui-modal';

import { ModalNames } from '../enum';

export const { showAction: showPermissionModal }: { showAction: string } = getModalActions(
  ModalNames.SHARED_PERMISSION_MODAL,
);
